import { axiosInstance } from './InitRequest';

export default axiosInstance;
